module.exports = __webpack_public_path__ + "img/ranking-programas.e6069f44.png";